import React from "react"
import styles from "../../styles/scss/components/form/formSystem.module.scss"

// Show/hide an optional block of fields ("Additional information").
// A real button with aria-expanded, so it is reachable and operable from the
// keyboard and announces its state. Controlled: the parent owns `open`,
// because the parent also decides when a section must be forced open (e.g.
// when it contains required fields).
const Disclosure = ({ id, title, open, onToggle, children }) => (
    <div className={styles.disclosure}>
        <button
            type="button"
            className={styles.disclosureButton}
            aria-expanded={open ? "true" : "false"}
            aria-controls={`${id}-panel`}
            onClick={onToggle}
        >
            <span>{title}</span>
            <span className={styles.disclosureIcon} aria-hidden="true">
                {open ? "−" : "+"}
            </span>
        </button>
        <div id={`${id}-panel`} className={styles.disclosurePanel} hidden={!open}>
            {open && children}
        </div>
    </div>
)

export default Disclosure
